import { StateFrame } from "./shapes";

const CHART_BAR =
  "M3.63636 1.81818C3.63636 0.814028 2.82234 0 1.81818 0C0.814028 0 0 0.814028 0 1.81818V38.1818C0 39.186 0.814028 40 1.81818 40H38.1818C39.186 40 40 39.186 40 38.1818C40 37.1777 39.186 36.3636 38.1818 36.3636H3.63636V1.81818ZM10.303 18.1818C11.3072 18.1818 12.1212 18.9958 12.1212 20V29.697C12.1212 30.7011 11.3072 31.5152 10.303 31.5152C9.29888 31.5152 8.48485 30.7011 8.48485 29.697V20C8.48485 18.9958 9.29888 18.1818 10.303 18.1818ZM20.6061 10.303C20.6061 9.29888 19.792 8.48485 18.7879 8.48485C17.7837 8.48485 16.9697 9.29888 16.9697 10.303V29.697C16.9697 30.7011 17.7837 31.5152 18.7879 31.5152C19.792 31.5152 20.6061 30.7011 20.6061 29.697V10.303ZM27.2727 18.1818C28.2769 18.1818 29.0909 18.9958 29.0909 20V29.697C29.0909 30.7011 28.2769 31.5152 27.2727 31.5152C26.2686 31.5152 25.4545 30.7011 25.4545 29.697V20C25.4545 18.9958 26.2686 18.1818 27.2727 18.1818ZM37.5758 10.303C37.5758 9.29888 36.7617 8.48485 35.7576 8.48485C34.7534 8.48485 33.9394 9.29888 33.9394 10.303V29.697C33.9394 30.7011 34.7534 31.5152 35.7576 31.5152C36.7617 31.5152 37.5758 30.7011 37.5758 29.697V10.303Z";

/** `ilu-no-charts` (10275:2302): ícone `chart-bar` 40×40. */
export function SemDados() {
  return (
    <StateFrame>
      {({ x, y, fill }) => (
        <path
          className={fill}
          transform={`translate(${x} ${y})`}
          d={CHART_BAR}
          fillRule="evenodd"
          clipRule="evenodd"
        />
      )}
    </StateFrame>
  );
}
